import { Outlet } from 'react-router-dom';
import { GlobalHeader } from '../GlobalHeader';
import { HeaderActionsProvider } from './HeaderActionsContext';
import './Layout.css';

export interface LayoutProps {
  /** Optional className for styling customization */
  className?: string;
}

export const Layout = ({ className }: LayoutProps) => {
  return (
    <HeaderActionsProvider>
      <div className={`layout ${className || ''}`}>
        <GlobalHeader />
        <main className="layout-main">
          <Outlet />
        </main>
      </div>
    </HeaderActionsProvider>
  );
};
